import React from "react";

const MENU_SECTIONS = [
  {
    title: "Signature Tasting",
    items: [
      { name: "Dahi ke Kebab, Beetroot Chutney", note: "Cold starter" },
      { name: "Malabar Prawn Moilee, Appam", note: "Coastal main" },
      { name: "Kashmiri Rogan Josh, Saffron Pulao", note: "North Indian" },
      { name: "Rasmalai Cheesecake, Pistachio Crumble", note: "Dessert" },
    ],
  },
  {
    title: "Corporate Luncheon",
    items: [
      { name: "Kachumber & Pomegranate Salad", note: "Vegan · Gluten-free" },
      { name: "Tandoori Murgh, Mint Chutney, Salad", note: "High protein" },
      { name: "Dal Makhani, Jeera Pulao, Butter Kulcha", note: "North Indian" },
      { name: "Bisi Bele Bath, Boondi Raita, Papad", note: "South Indian" },
      { name: "Shrikhand, Seasonal Fruit", note: "Light dessert" },
    ],
  },
  {
    title: "Soirée & Bar",
    items: [
      { name: "Galouti Kebab on Mini Sheermal", note: "Hot passed" },
      { name: "Pani Puri Shot Station", note: "Live · Interactive" },
      { name: "Chaat Trolley — Dahi · Aloo Tikki · Bhel", note: "Live station" },
      { name: "Tawa Dosa & Uttapam Counter", note: "Live · South" },
      { name: "Paan & Kulfi Bar", note: "Sweet finish" },
    ],
  },
];

const GALLERY = [
  "https://images.unsplash.com/photo-1633383718081-22ac93e3db65?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzB8fGluZGlhbiUyMGZvb2R8ZW58MHx8MHx8fDA%3D&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1619193100179-af4cc742ed3e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTUyfHxpbmRpYW4lMjBmb29kfGVufDB8fDB8fHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1732949299022-ccae7b09600f?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTgyfHxpbmRpYW4lMjBmb29kfGVufDB8fDB8fHww&ixlib=rb-4.1.0&q=85",
];

export default function Menu() {
  return (
    <section
      id="menu"
      data-testid="menu-section"
      className="py-28 md:py-36 bg-[#1E3A5F] text-[#FDFBF7] relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-x-4 gap-y-10 md:gap-10">
          <div className="col-span-12 lg:col-span-5">
            <p className="label-eyebrow" style={{ color: "#CBA365" }}>
              05 · The Menu
            </p>
            <h2 className="font-serif mt-5 text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
              A seasonal
              <br />
              <span className="italic text-[#CBA365]">look book</span>
              <br />
              of what we serve.
            </h2>
            <p className="mt-8 text-[#FDFBF7]/70 font-light leading-relaxed max-w-md">
              We publish a fresh menu every quarter and tailor it around your
              cuisine preferences, dietary needs and budget. Below, a small
              taste of the current season.
            </p>
          </div>

          {/* Gallery stack */}
          <div className="col-span-12 lg:col-span-7 grid grid-cols-6 gap-4 lg:gap-5">
            <div className="col-span-4 aspect-[4/5] overflow-hidden">
              <img
                src={GALLERY[0]}
                alt="Signature plating"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="col-span-2 flex flex-col gap-4 lg:gap-5">
              <div className="aspect-square overflow-hidden">
                <img
                  src={GALLERY[1]}
                  alt="Dessert"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 overflow-hidden">
                <img
                  src={GALLERY[2]}
                  alt="Main course"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Menu columns */}
        <div className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {MENU_SECTIONS.map((s) => (
            <div key={s.title} data-testid={`menu-column-${s.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <h3 className="font-serif text-2xl md:text-3xl text-[#CBA365]">
                {s.title}
              </h3>
              <ul className="mt-6 divide-y divide-[#FDFBF7]/15">
                {s.items.map((i) => (
                  <li
                    key={i.name}
                    className="py-4 flex items-start justify-between gap-6"
                  >
                    <span className="font-light text-[#FDFBF7]/90 text-[15px] leading-snug">
                      {i.name}
                    </span>
                    <span className="text-[10px] uppercase tracking-[0.22em] text-[#FDFBF7]/50 pt-1 whitespace-nowrap">
                      {i.note}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
